export default {"src":"https://images-cdn.curipod.com/d-7d558a72/_next/static/media/rocket.9360f2a3.svg","height":199,"width":200};